const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDance(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 54.538 54.538",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#010002"
    },
    d: "M44.391,0c-1.728,0-3.13,1.401-3.13,3.13v5.472c-4.039,3.497-8.411,6.553-13.24,8.84 c-0.707,0.15-1.379,0.456-1.973,0.878c-0.066,0.028-0.132,0.061-0.199,0.088c-0.979,0.405-1.522,1.187-1.707,2.032 c-4.73-0.482-9.354-1.355-13.861-2.926c-3.277-1.143-4.672,4.043-1.427,5.175c5.299,1.848,10.792,2.729,16.368,3.226 c0.014,0.002,0.024-0.001,0.038,0c3.945,3.791,8.759,5.824,14.236,5.928c0.653,0.012,1.241-0.084,1.766-0.259v19.825 c0,1.729,1.402,3.129,3.133,3.129s3.132-1.396,3.132-3.129V3.13C47.523,1.401,46.121,0,44.391,0z M41.261,22.075 c-0.504-0.18-1.067-0.287-1.694-0.298c-2.056-0.039-3.813-0.554-5.417-1.583c2.473-1.415,4.837-2.991,7.111-4.718V22.075z  M22.761,6.168c2.964,0,5.368,2.403,5.368,5.367s-2.403,5.367-5.368,5.367c-2.964,0-5.367-2.403-5.367-5.367 S19.797,6.168,22.761,6.168z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDance);
export default __webpack_public_path__ + "static/media/dance.5c7cbb7a82e0c2cabf9b177d707ba828.svg";
export { ForwardRef as ReactComponent };